"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[91],{

/***/ 1931:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _data_Feature_collections_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1843);





var Explore_collection_item = function(param) {
    var itemFor = param.itemFor;
    var sortedCollectionData = useSelector(function(state) {
        return state.counter;
    }).sortedCollectionData;
    var ref = useState([]), itemData = ref[0], setItemData = ref[1];
    useEffect(function() {
        if (itemFor === "userPage") {
            setItemData(Feature_collections_data.slice(0, 4));
            console.log(itemData);
        } else {
            setItemData(sortedCollectionData);
        }
    }, [
        sortedCollectionData,
        itemFor
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: itemData.map(function(item) {
            var id = item.id, bigImage = item.bigImage, subImage1 = item.subImage1, subImage2 = item.subImage2, subImage3 = item.subImage3, userImage = item.userImage, title = item.title, itemsCount = item.itemsCount, userName = item.userName;
            return /*#__PURE__*/ _jsx("article", {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            href: "/collection/avatar_1",
                            children: /*#__PURE__*/ _jsxs("a", {
                                className: "flex space-x-[0.625rem]",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "w-[74.5%]",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: bigImage,
                                            alt: "item 1",
                                            className: "h-full w-full rounded-[0.625rem] object-cover",
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "flex w-1/3 flex-col space-y-[0.625rem]",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage1,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage2,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                src: subImage3,
                                                alt: "item 1",
                                                className: "h-full rounded-[0.625rem] object-cover",
                                                loading: "lazy"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            href: "/collection/avatar_1",
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-2 flex items-center justify-between text-sm font-medium tracking-tight",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-wrap items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/user/avatar_6",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "mr-2 shrink-0",
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    src: userImage,
                                                    alt: "owner",
                                                    className: "h-5 w-5 rounded-full"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "dark:text-jacarta-400 mr-1",
                                            children: "by"
                                        }),
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/user/avatar_6",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-accent",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: userName
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "dark:text-jacarta-300 text-sm",
                                    children: [
                                        itemsCount,
                                        " Items"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, id);
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Explore_collection_item)));


/***/ }),

/***/ 6091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user_User_items; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(6929);
// EXTERNAL MODULE: ./components/collectrions/Activity_item.jsx
var Activity_item = __webpack_require__(5536);
// EXTERNAL MODULE: ./components/collectrions/On_sale.jsx
var On_sale = __webpack_require__(3960);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/categories/trending_categories_items.jsx
var trending_categories_items = __webpack_require__(7282);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./components/categories/categoryItem.jsx
var categoryItem = __webpack_require__(8340);
// EXTERNAL MODULE: ./data/categories_data.js
var categories_data = __webpack_require__(3996);
// EXTERNAL MODULE: ./components/dropdown/recently_added_dropdown.jsx
var recently_added_dropdown = __webpack_require__(7668);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./redux/counterSlice.js
var counterSlice = __webpack_require__(8362);
// EXTERNAL MODULE: ./node_modules/@demox-labs/aleo-wallet-adapter-react/dist/index.js + 3 modules
var dist = __webpack_require__(9023);
// EXTERNAL MODULE: ./lib/client/aleo/index.js + 4 modules
var aleo = __webpack_require__(6833);
// EXTERNAL MODULE: ./node_modules/react-alert/dist/esm/react-alert.js + 11 modules
var react_alert = __webpack_require__(406);
;// CONCATENATED MODULE: ./components/categories/public_trending_categories_items.jsx













function loadUserWalletContent(toFetchPublicKey, publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections) {
    return _loadUserWalletContent.apply(this, arguments);
}
function _loadUserWalletContent() {
    _loadUserWalletContent = (0,_async_to_generator/* default */.Z)(function(toFetchPublicKey, publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections) {
        var user_collections, ownedTokens, e, ref, err_str;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading) return [
                        2
                    ];
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    user_collections = [];
                    if (!(publicKey && requestRecords)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,aleo/* get_user_collections */.iV)(publicKey, requestRecords)
                    ];
                case 2:
                    user_collections = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        (0,aleo/* get_public_tokens_owned_by */.lR)(toFetchPublicKey)
                    ];
                case 4:
                    ownedTokens = _state.sent();
                    ownedTokens = ownedTokens.filter(function(token) {
                        return token;
                    });
                    return [
                        4,
                        (0,aleo/* loadTokensData */._3)(ownedTokens)
                    ];
                case 5:
                    ownedTokens = _state.sent();
                    setTokens(ownedTokens);
                    setCollections(user_collections);
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    err_str = (e === null || e === void 0 ? void 0 : (ref = e.error) === null || ref === void 0 ? void 0 : ref.message) || (e === null || e === void 0 ? void 0 : e.message) || e + "";
                    alert.error(err_str);
                    return [
                        3,
                        7
                    ];
                case 7:
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _loadUserWalletContent.apply(this, arguments);
}
var Trending_categories_items = function(param) {
    var category = param.category, setCategory = param.setCategory, toFetchPublicKey = param.toFetchPublicKey;
    var ref = (0,react.useState)([]), tokens = ref[0], setTokens = ref[1];
    var ref1 = (0,react.useState)([]), collections = ref1[0], setCollections = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var trendingCategorySorText = (0,es/* useSelector */.v9)(function(state) {
        return state.counter;
    }).trendingCategorySorText;
    var ref2 = (0,dist/* useWallet */.Os)(), publicKey = ref2.publicKey, requestRecords = ref2.requestRecords;
    var ref3 = (0,react.useState)(0), filterVal = ref3[0], setFilterVal = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var alert = (0,react_alert/* useAlert */.VY)();
    var ref5 = (0,react.useState)(false), ownedPublicLoading = ref5[0], setOwnedPublicLoading = ref5[1];
    (0,react.useEffect)(function() {
        loadUserWalletContent(toFetchPublicKey, publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections);
    }, [
        filterVal,
        category,
        publicKey,
        requestRecords,
        toFetchPublicKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500"
                })
            }),
            !loading && tokens.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-2xl font-semibold mb-2",
                            children: [
                                "No ",
                                filterVal === 0 ? "public" : filterVal === 1 ? "private" : "",
                                " token found"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-sm text-jacarta-500 dark:text-jacarta-400 normal-case ",
                            children: "This address does not own any public token."
                        })
                    ]
                })
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(categoryItem/* default */.Z, {
                noFeature: true,
                tokens: tokens,
                collections: collections
            })
        ]
    });
};
/* harmony default export */ var public_trending_categories_items = (Trending_categories_items);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/collectrions/collections.jsx









function loadUserWalletCollections(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData) {
    return _loadUserWalletCollections.apply(this, arguments);
}
function _loadUserWalletCollections() {
    _loadUserWalletCollections = (0,_async_to_generator/* default */.Z)(function(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData) {
        var collections_data, collections;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading) return [
                        2
                    ];
                    setLoading(true);
                    return [
                        4,
                        (0,aleo/* get_user_collections */.iV)(publicKey, requestRecords)
                    ];
                case 1:
                    collections_data = _state.sent();
                    return [
                        4,
                        Promise.all(collections_data.map(aleo/* loadCollectionData */.$6))
                    ];
                case 2:
                    collections = _state.sent();
                    setData(collections);
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _loadUserWalletCollections.apply(this, arguments);
}
var Collections = function(param) {
    var setCategory = param.setCategory;
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,dist/* useWallet */.Os)(), publicKey = ref2.publicKey, requestRecords = ref2.requestRecords;
    var alert = (0,react_alert/* useAlert */.VY)();
    (0,react.useEffect)(function() {
        loadUserWalletCollections(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData);
    }, [
        publicKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-pane fade",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:flex",
                style: {
                    flexFlow: "column"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pr-10",
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500"
                            })
                        }),
                        !loading && data.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-2xl font-semibold mb-2",
                                        children: "No collection found"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm text-jacarta-500 dark:text-jacarta-400 normal-case ",
                                        children: "Create one to begin minting NFTs"
                                    })
                                ]
                            })
                        }),
                        !loading && data.map(function(collection) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/collection/".concat(collection.hex_id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    style: {
                                        flexDirection: "row",
                                        justifyContent: "space-between"
                                    },
                                    className: "dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl relative flex items-center border bg-white p-8 transition-shadow hover:shadow-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                flexDirection: "row",
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    className: "mr-5 self-start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: collection.public_data.metadata.icon_url,
                                                        alt: collection.public_data.metadata.name,
                                                        height: 50,
                                                        width: 50,
                                                        objectFit: "cover",
                                                        className: "rounded-2lg",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white",
                                                            children: collection.public_data.metadata.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm",
                                                            children: collection.public_data.metadata.ticker
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-jacarta-300 block text-xs normal-case",
                                                            children: [
                                                                "Tokens ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "uppercase",
                                                                    children: collection.public_data.publicizable ? "can" : "cannot"
                                                                }),
                                                                " be made public. Tokens ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "uppercase",
                                                                    children: collection.data.updatable ? "can" : "cannot"
                                                                }),
                                                                " be updated/burned."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "flex flex-wrap items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-1 mr-2.5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/collection/".concat(collection.hex_id, "/manage"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "transition delay-50 bg-blue-500 hover:scale-110 hover:bg-indigo-500 duration-150",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                    className: "icon mr-1 h-4 w-4 transition-colors fill-white",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                                                        xlinkHref: "/icons.svg#icon-details"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "manage"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, collection.hex_id);
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var collections = (Collections);

// EXTERNAL MODULE: ./components/collectrions/explore_collection_item.jsx
var explore_collection_item = __webpack_require__(1931);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/tabs/Activity_tab.jsx
var Activity_tab = __webpack_require__(716);
// EXTERNAL MODULE: ./components/userId.jsx
var userId = __webpack_require__(1632);
;// CONCATENATED MODULE: ./components/user/User_items.jsx














var tabItemData = [
    {
        id: 1,
        text: "Owned",
        icon: "owned"
    },
    {
        id: 2,
        text: "For Sale",
        icon: "on-sale"
    },
    {
        id: 4,
        text: "Collections",
        icon: "listing"
    },
    {
        id: 5,
        text: "Proofs",
        icon: "puzzle"
    }
];
var tabItemDataDisconnected = [
    {
        id: 2,
        text: "For Sale",
        icon: "on-sale"
    },
    {
        id: 3,
        text: "Owned Publicly",
        icon: "owned"
    }, 
];
var user_changed_yet = false;
var setItemActiveExt = function(val, setItemActive) {
    setItemActive(val);
};
var User_items = function(param) {
    var public_key = param.public_key;
    var publicKey = (0,dist/* useWallet */.Os)().publicKey;
    var ref = (0,react.useState)(1), itemActive = ref[0], setItemActive = ref[1];
    var ref1 = (0,react.useState)(tabItemDataDisconnected), tabItem = ref1[0], setTabItem = ref1[1];
    (0,react.useEffect)(function() {
        if (!publicKey || publicKey !== public_key) {
            setItemActiveExt(2, setItemActive);
            setTabItem(tabItemDataDisconnected);
        } else {
            setTabItem(tabItemData);
            window.user_initiated = true;
            if (!user_changed_yet) {
                setItemActiveExt(1, setItemActive);
            }
        }
    }, [
        publicKey,
        public_key
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "relative pt-20 pb-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: "fit-content",
                        margin: "auto",
                        marginBottom: "2rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(userId/* default */.Z, {
                        classes: "js-copy-clipboard dark:bg-jacarta-700 border-jacarta-100 hover:bg-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 flex w-full select-none items-center rounded-lg border bg-white py-3 px-4",
                        userId: public_key || "",
                        cutMiddle: true,
                        shortId: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    className: "pointer-events-none absolute inset-0 -z-10 dark:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/gradient_light.jpg",
                        alt: "gradient",
                        className: "h-full w-full",
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tabs */.mQ, {
                        className: "tabs",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabList */.td, {
                                className: "nav nav-tabs scrollbar-custom mb-12 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-100 pb-px dark:border-jacarta-600 md:justify-center",
                                children: tabItem.map(function(param) {
                                    var id = param.id, text = param.text, icon = param.icon;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Tab */.OK, {
                                        className: "nav-item",
                                        role: "presentation",
                                        onClick: function() {
                                            user_changed_yet = true;
                                            return setItemActiveExt(id, setItemActive);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: itemActive === id ? "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white active" : "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    className: "icon mr-1 h-5 w-5 fill-current" + (icon === "puzzle" ? " h-6 w-6" : ""),
                                                    children: icon === "pig" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        style: {
                                                            transform: "scale(0.07)"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                        d: "M220.976,84.214h-6.054c-6.465-14.758-16.708-27.538-29.988-37.411l8.281-28.347c0.809-2.775-0.023-5.767-2.146-7.725 c-2.128-1.96-5.179-2.551-7.872-1.514l-47.099,17.994c-5.653-0.799-11.301-1.202-16.82-1.202 c-38.053,0-70.042,17.079-87.94,43.78c-13.46-1.174-16.008-9.987-16.282-11.149c-0.852-4.063-4.816-6.696-8.902-5.902 c-4.124,0.804-6.817,4.801-6.011,8.925C1.456,68.396,8.03,80.075,23.6,83.882c-4.956,11.342-7.667,23.904-7.667,37.282 c0,26.564,11.195,51.226,30.997,68.89c-9.853,10.457-9.668,26.98,0.561,37.206c5.044,5.047,11.755,7.827,18.892,7.827 c7.137,0,13.845-2.78,18.892-7.827l12.815-12.815c15.828,2.843,32.702,2.417,48.068-1.154l13.969,13.972 c5.047,5.044,11.758,7.824,18.892,7.824c7.134,0,13.842-2.78,18.892-7.827c10.411-10.416,10.411-27.365-0.003-37.784 l-2.747-2.744c8.357-8.273,15.062-17.994,19.734-28.618h6.079c12.587,0,22.826-10.241,22.826-22.826V107.04 C243.801,94.455,233.563,84.214,220.976,84.214z M228.584,135.278c0,4.195-3.414,7.609-7.609,7.609H209.77 c-3.183,0-6.029,1.978-7.134,4.963c-4.679,12.628-12.754,23.954-23.356,32.755c-1.646,1.367-2.643,3.366-2.742,5.504 s0.708,4.22,2.222,5.734l8.387,8.387c4.484,4.484,4.484,11.783,0.003,16.262c-2.171,2.174-5.06,3.371-8.131,3.371 c-3.071,0-5.963-1.197-8.134-3.368l-17.025-17.028c-1.446-1.446-3.388-2.229-5.379-2.229c-0.675,0-1.352,0.089-2.019,0.271 c-8.636,2.379-17.784,3.584-27.183,3.584c-7.505,0-14.933-0.789-22.08-2.343c-2.536-0.553-5.169,0.223-6.997,2.057 l-15.689,15.689c-2.171,2.171-5.06,3.368-8.134,3.368c-3.071,0-5.96-1.197-8.134-3.368c-4.484-4.487-4.484-11.781,0-16.265 l5.384-5.384c1.565-1.562,2.371-3.731,2.209-5.937c-0.16-2.206-1.276-4.233-3.051-5.549 c-20.109-14.933-31.641-37.601-31.641-62.2c0-45.57,37.888-79.935,88.132-79.935c5.387,0,10.933,0.444,16.483,1.321 c1.314,0.211,2.66,0.068,3.901-0.408l34.652-13.236L168.8,47.772c-0.936,3.206,0.327,6.65,3.117,8.486 c14.362,9.468,24.992,22.681,30.739,38.208c1.106,2.985,3.954,4.968,7.134,4.968h11.185c4.195,0,7.609,3.414,7.609,7.609V135.278 z"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                                        cx: "166.674",
                                                                        cy: "99.388",
                                                                        r: "10.568"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                        x: "97.142",
                                                                        y: "55.216",
                                                                        width: "44.383",
                                                                        height: "15.217"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                                        xlinkHref: "/icons.svg#icon-".concat(icon)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-display text-base font-medium",
                                                    children: text
                                                })
                                            ]
                                        })
                                    }, id);
                                })
                            }),
                            tabItem.length === 4 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(trending_categories_items/* default */.Z, {
                                                category: itemActive,
                                                setCategory: setItemActive
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(On_sale/* default */.Z, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collections, {
                                                category: itemActive,
                                                setCategory: setItemActive
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Activity_tab/* default */.Z, {
                                                category: itemActive,
                                                setCategory: setItemActive
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(On_sale/* default */.Z, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(public_trending_categories_items, {
                                                toFetchPublicKey: public_key,
                                                category: itemActive,
                                                setCategory: setItemActive
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var user_User_items = (User_items);


/***/ }),

/***/ 1632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _tippyjs_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2697);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);




var UserId = function(param) {
    var classes = param.classes, userId = param.userId, shortId = param.shortId, cutMiddle = param.cutMiddle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), copied = ref[0], setCopied = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setTimeout(function() {
            setCopied(false);
        }, 2000);
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tippyjs_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            className: "p-1",
            hideOnClick: false,
            content: copied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "copied"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: "copy"
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: classes,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default()), {
                        text: userId,
                        onCopy: function() {
                            return setCopied(true);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                textTransform: "none"
                            },
                            children: !shortId ? userId : cutMiddle ? "".concat(userId.slice(0, 6), "...").concat(userId.slice(-8)) : "".concat(userId.substring(0, 17), "...")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        width: "24",
                        height: "24",
                        className: "dark:fill-jacarta-300 fill-jacarta-500 ml-auto mb-px h-4 w-4",
                        style: {
                            marginLeft: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                d: "M0 0h24v24H0z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserId);


/***/ })

}]);